// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import { LiftFloor, LiftFloorT, verifyLiftFloor } from "./lift-floor";
import { LiftType } from "./lift-type";
import { Uuid, UuidT, verifyUuid } from "../front-end/uuid";

/**
 * Full lift record matching the `lifts` `PostgreSQL` table.
 */
export class Lift implements flatbuffers.IUnpackableObject<LiftT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): Lift {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsLift(bb: flatbuffers.ByteBuffer, obj?: Lift): Lift {
    return (obj || new Lift()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsLift(bb: flatbuffers.ByteBuffer, obj?: Lift): Lift {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new Lift()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  id(obj?: Uuid): Uuid | null {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset
      ? (obj || new Uuid()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  bankId(obj?: Uuid): Uuid | null {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset
      ? (obj || new Uuid()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  organizationId(obj?: Uuid): Uuid | null {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset
      ? (obj || new Uuid()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  name(): string;
  name(optionalEncoding: flatbuffers.Encoding): string | Uint8Array;
  name(optionalEncoding?: any): string | Uint8Array {
    const offset = this.bb!.__offset(this.bb_pos, 10);
    return this.bb!.__string(this.bb_pos + offset, optionalEncoding);
  }

  type(): LiftType {
    const offset = this.bb!.__offset(this.bb_pos, 12);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : LiftType.ELEVATOR;
  }

  position(): number {
    const offset = this.bb!.__offset(this.bb_pos, 14);
    return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0;
  }

  questId(): number {
    const offset = this.bb!.__offset(this.bb_pos, 16);
    return offset ? this.bb!.readInt16(this.bb_pos + offset) : 0;
  }

  createdAt(): string | null;
  createdAt(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  createdAt(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 18);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  updatedAt(): string | null;
  updatedAt(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  updatedAt(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 20);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  deletedAt(): string | null;
  deletedAt(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  deletedAt(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 22);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  /**
   * Per-lift floor configurations — which doors are active at each floor.
   */
  liftFloors(index: number, obj?: LiftFloor): LiftFloor | null {
    const offset = this.bb!.__offset(this.bb_pos, 24);
    return offset
      ? (obj || new LiftFloor()).__init(
          this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4),
          this.bb!,
        )
      : null;
  }

  liftFloorsLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 24);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  /**
   * Explicit per-lift car number (operator-set), distinct from
   * position/ordering; read by the `LobbyVision2` template expander's
   * `LiftCarNum` source. Appended last for wire back-compat.
   */
  carNum(): number {
    const offset = this.bb!.__offset(this.bb_pos, 26);
    return offset ? this.bb!.readUint16(this.bb_pos + offset) : 0;
  }

  /**
   * OPC deployment path — the per-car segment of this lift's vendor node path,
   * written to `Opc.Lift.name` (e.g. "G1", or "SE1" for the Kone OPC UA device).
   *
   * Deliberately distinct from `name`: `name` is the LN2 display label an operator
   * chose, while this is the token the vendor's OPC server actually exposes. The two
   * are independent and must stay independently editable — a bank named "Service
   * Elevators" can address cars called "SE1" and "SE2".
   *
   * Also the source of the synthesized `Opc.Mapping.car_num_to_name` value for this
   * lift, which `vts/src/vendors/opc.rs` uses to resolve an OPC group name back to
   * this lift's UUID. Appended at end of table for `FlatBuffer` wire compatibility.
   */
  vendorLiftPath(): string | null;
  vendorLiftPath(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  vendorLiftPath(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 28);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  /**
   * OPC DA only — the OPC DA SUBSCRIPTION GROUP name for this car, written to
   * `Opc.Group.group_name`.
   *
   * Not a path segment. `opc_protocol`'s `Localization for OpcItem` sets
   * `OpcItem.group_name` from the group name while separately prepending
   * `group.opc_path_name` to the item name, so the two are read from different slots
   * and legitimately differ — at the `BNA_Nash` site every group shares
   * `path_name` `G1_G5` while `group_name` runs "G1".."G5".
   *
   * Lift-scoped because every dictionary captured so far is one group per car with a
   * per-car group name. When empty, `LiftCloud` falls back to `vendor_lift_path`.
   * Appended at end of table for `FlatBuffer` wire compatibility.
   */
  vendorGroupName(): string | null;
  vendorGroupName(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  vendorGroupName(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 30);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  /**
   * Presence signal for the two `OPC` vendor segments above.
   *
   * `FlatBuffers` cannot express a null string, so on the wire an empty segment and
   * an absent one are byte-identical, and `LiftCloud` cannot tell "the operator
   * cleared this path" apart from "this client never models the field." Without a
   * signal, the update path can only ever overwrite a stored segment, never clear it.
   *
   * When this is `true`, the editor is authoritative over BOTH segments for this
   * save: `LiftCloud` writes each segment to its value, or to `NULL` when it is
   * empty/whitespace (so a cleared input deletes the stored path). A cleared
   * `vendor_group_name` still resolves through the existing fallback to
   * `vendor_lift_path`, so clearing the group name alone asks for the car's path
   * token rather than losing its subscription group.
   *
   * When this is `false` (the default), the two segments are treated as
   * NOT-PROVIDED and the stored columns are left untouched — the exact guarded
   * behaviour every existing client relies on. Old senders that predate this field
   * read `false` (the `FlatBuffer` default), so appending it is fully backward- and
   * forward-compatible: no client that does not explicitly set it can clear a path,
   * and no client has to be updated in lockstep for existing saves to keep working.
   *
   * Mirrors `Archive.Bank.vendor_paths_provided`, which carries the same rule for
   * the three bank-level segments. Only the editors that round-trip both segments
   * together (the Setup Wizard's `Lifts & Floors` step) set this `true`. Appended at
   * end of table for `FlatBuffer` wire compatibility.
   */
  vendorPathsProvided(): boolean {
    const offset = this.bb!.__offset(this.bb_pos, 32);
    return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : false;
  }

  static startLift(builder: flatbuffers.Builder) {
    builder.startObject(15);
  }

  static addId(builder: flatbuffers.Builder, idOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, idOffset, 0);
  }

  static addBankId(builder: flatbuffers.Builder, bankIdOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, bankIdOffset, 0);
  }

  static addOrganizationId(builder: flatbuffers.Builder, organizationIdOffset: flatbuffers.Offset) {
    builder.addFieldOffset(2, organizationIdOffset, 0);
  }

  static addName(builder: flatbuffers.Builder, nameOffset: flatbuffers.Offset) {
    builder.addFieldOffset(3, nameOffset, 0);
  }

  static addType(builder: flatbuffers.Builder, type: LiftType) {
    builder.addFieldInt8(4, type, LiftType.ELEVATOR);
  }

  static addPosition(builder: flatbuffers.Builder, position: number) {
    builder.addFieldInt32(5, position, 0);
  }

  static addQuestId(builder: flatbuffers.Builder, questId: number) {
    builder.addFieldInt16(6, questId, 0);
  }

  static addCreatedAt(builder: flatbuffers.Builder, createdAtOffset: flatbuffers.Offset) {
    builder.addFieldOffset(7, createdAtOffset, 0);
  }

  static addUpdatedAt(builder: flatbuffers.Builder, updatedAtOffset: flatbuffers.Offset) {
    builder.addFieldOffset(8, updatedAtOffset, 0);
  }

  static addDeletedAt(builder: flatbuffers.Builder, deletedAtOffset: flatbuffers.Offset) {
    builder.addFieldOffset(9, deletedAtOffset, 0);
  }

  static addLiftFloors(builder: flatbuffers.Builder, liftFloorsOffset: flatbuffers.Offset) {
    builder.addFieldOffset(10, liftFloorsOffset, 0);
  }

  static createLiftFloorsVector(
    builder: flatbuffers.Builder,
    data: flatbuffers.Offset[],
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!);
    }
    return builder.endVector();
  }

  static startLiftFloorsVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static addCarNum(builder: flatbuffers.Builder, carNum: number) {
    builder.addFieldInt16(11, carNum, 0);
  }

  static addVendorLiftPath(builder: flatbuffers.Builder, vendorLiftPathOffset: flatbuffers.Offset) {
    builder.addFieldOffset(12, vendorLiftPathOffset, 0);
  }

  static addVendorGroupName(
    builder: flatbuffers.Builder,
    vendorGroupNameOffset: flatbuffers.Offset,
  ) {
    builder.addFieldOffset(13, vendorGroupNameOffset, 0);
  }

  static addVendorPathsProvided(builder: flatbuffers.Builder, vendorPathsProvided: boolean) {
    builder.addFieldInt8(14, +vendorPathsProvided, +false);
  }

  static endLift(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    builder.requiredField(offset, 4); // id
    builder.requiredField(offset, 6); // bank_id
    builder.requiredField(offset, 8); // organization_id
    builder.requiredField(offset, 10); // name
    return offset;
  }

  unpack(): LiftT {
    return new LiftT(
      this.id() !== null ? this.id()!.unpack() : null,
      this.bankId() !== null ? this.bankId()!.unpack() : null,
      this.organizationId() !== null ? this.organizationId()!.unpack() : null,
      this.name(),
      this.type(),
      this.position(),
      this.questId(),
      this.createdAt(),
      this.updatedAt(),
      this.deletedAt(),
      this.bb!.createObjList<LiftFloor, LiftFloorT>(
        this.liftFloors.bind(this),
        this.liftFloorsLength(),
      ),
      this.carNum(),
      this.vendorLiftPath(),
      this.vendorGroupName(),
      this.vendorPathsProvided(),
    );
  }

  unpackTo(_o: LiftT): void {
    _o.id = this.id() !== null ? this.id()!.unpack() : null;
    _o.bankId = this.bankId() !== null ? this.bankId()!.unpack() : null;
    _o.organizationId = this.organizationId() !== null ? this.organizationId()!.unpack() : null;
    _o.name = this.name();
    _o.type = this.type();
    _o.position = this.position();
    _o.questId = this.questId();
    _o.createdAt = this.createdAt();
    _o.updatedAt = this.updatedAt();
    _o.deletedAt = this.deletedAt();
    _o.liftFloors = this.bb!.createObjList<LiftFloor, LiftFloorT>(
      this.liftFloors.bind(this),
      this.liftFloorsLength(),
    );
    _o.carNum = this.carNum();
    _o.vendorLiftPath = this.vendorLiftPath();
    _o.vendorGroupName = this.vendorGroupName();
    _o.vendorPathsProvided = this.vendorPathsProvided();
  }

  unpackFields(...fields: string[]): LiftT {
    const t = new LiftT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("id")) {
      t.id = this.id() !== null ? this.id()!.unpack() : null;
    }
    if (fieldSet.has("bank_id")) {
      t.bankId = this.bankId() !== null ? this.bankId()!.unpack() : null;
    }
    if (fieldSet.has("organization_id")) {
      t.organizationId = this.organizationId() !== null ? this.organizationId()!.unpack() : null;
    }
    if (fieldSet.has("name")) {
      t.name = this.name();
    }
    if (fieldSet.has("type")) {
      t.type = this.type();
    }
    if (fieldSet.has("position")) {
      t.position = this.position();
    }
    if (fieldSet.has("quest_id")) {
      t.questId = this.questId();
    }
    if (fieldSet.has("created_at")) {
      t.createdAt = this.createdAt();
    }
    if (fieldSet.has("updated_at")) {
      t.updatedAt = this.updatedAt();
    }
    if (fieldSet.has("deleted_at")) {
      t.deletedAt = this.deletedAt();
    }
    if (fieldSet.has("lift_floors")) {
      t.liftFloors = this.bb!.createObjList<LiftFloor, LiftFloorT>(
        this.liftFloors.bind(this),
        this.liftFloorsLength(),
      );
    }
    if (fieldSet.has("car_num")) {
      t.carNum = this.carNum();
    }
    if (fieldSet.has("vendor_lift_path")) {
      t.vendorLiftPath = this.vendorLiftPath();
    }
    if (fieldSet.has("vendor_group_name")) {
      t.vendorGroupName = this.vendorGroupName();
    }
    if (fieldSet.has("vendor_paths_provided")) {
      t.vendorPathsProvided = this.vendorPathsProvided();
    }
    return t;
  }
}

export class LiftT implements flatbuffers.IGeneratedObject {
  constructor(
    public id: UuidT | null = null,
    public bankId: UuidT | null = null,
    public organizationId: UuidT | null = null,
    public name: string | Uint8Array | null = null,
    public type: LiftType = LiftType.ELEVATOR,
    public position: number = 0,
    public questId: number = 0,
    public createdAt: string | Uint8Array | null = null,
    public updatedAt: string | Uint8Array | null = null,
    public deletedAt: string | Uint8Array | null = null,
    public liftFloors: LiftFloorT[] = [],
    public carNum: number = 0,
    public vendorLiftPath: string | Uint8Array | null = null,
    public vendorGroupName: string | Uint8Array | null = null,
    public vendorPathsProvided: boolean = false,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    if (this.id === null || this.id === undefined) {
      throw new Error('Required field "id" is not set');
    }
    if (this.bankId === null || this.bankId === undefined) {
      throw new Error('Required field "bank_id" is not set');
    }
    if (this.organizationId === null || this.organizationId === undefined) {
      throw new Error('Required field "organization_id" is not set');
    }
    if (this.name === null || this.name === undefined) {
      throw new Error('Required field "name" is not set');
    }
    const id = this.id !== null ? this.id!.pack(builder) : 0;
    const bankId = this.bankId !== null ? this.bankId!.pack(builder) : 0;
    const organizationId = this.organizationId !== null ? this.organizationId!.pack(builder) : 0;
    const name = this.name !== null ? builder.createString(this.name!) : 0;
    const createdAt = this.createdAt !== null ? builder.createString(this.createdAt!) : 0;
    const updatedAt = this.updatedAt !== null ? builder.createString(this.updatedAt!) : 0;
    const deletedAt = this.deletedAt !== null ? builder.createString(this.deletedAt!) : 0;
    const liftFloors = Lift.createLiftFloorsVector(
      builder,
      builder.createObjectOffsetList(this.liftFloors),
    );
    const vendorLiftPath =
      this.vendorLiftPath !== null ? builder.createString(this.vendorLiftPath!) : 0;
    const vendorGroupName =
      this.vendorGroupName !== null ? builder.createString(this.vendorGroupName!) : 0;

    Lift.startLift(builder);
    Lift.addId(builder, id);
    Lift.addBankId(builder, bankId);
    Lift.addOrganizationId(builder, organizationId);
    Lift.addName(builder, name);
    Lift.addType(builder, this.type);
    Lift.addPosition(builder, this.position);
    Lift.addQuestId(builder, this.questId);
    Lift.addCreatedAt(builder, createdAt);
    Lift.addUpdatedAt(builder, updatedAt);
    Lift.addDeletedAt(builder, deletedAt);
    Lift.addLiftFloors(builder, liftFloors);
    Lift.addCarNum(builder, this.carNum);
    Lift.addVendorLiftPath(builder, vendorLiftPath);
    Lift.addVendorGroupName(builder, vendorGroupName);
    Lift.addVendorPathsProvided(builder, this.vendorPathsProvided);

    return Lift.endLift(builder);
  }

  clone(): LiftT {
    const obj = new LiftT();
    obj.id = this.id !== null ? this.id!.clone() : null;
    obj.bankId = this.bankId !== null ? this.bankId!.clone() : null;
    obj.organizationId = this.organizationId !== null ? this.organizationId!.clone() : null;
    obj.name = this.name;
    obj.type = this.type;
    obj.position = this.position;
    obj.questId = this.questId;
    obj.createdAt = this.createdAt;
    obj.updatedAt = this.updatedAt;
    obj.deletedAt = this.deletedAt;
    obj.liftFloors = this.liftFloors.map((e) => e.clone());
    obj.carNum = this.carNum;
    obj.vendorLiftPath = this.vendorLiftPath;
    obj.vendorGroupName = this.vendorGroupName;
    obj.vendorPathsProvided = this.vendorPathsProvided;
    return obj;
  }

  equals(other: LiftT): boolean {
    if (this.id !== null && other.id !== null) {
      if (!this.id!.equals(other.id!)) return false;
    } else if (this.id !== other.id) return false;
    if (this.bankId !== null && other.bankId !== null) {
      if (!this.bankId!.equals(other.bankId!)) return false;
    } else if (this.bankId !== other.bankId) return false;
    if (this.organizationId !== null && other.organizationId !== null) {
      if (!this.organizationId!.equals(other.organizationId!)) return false;
    } else if (this.organizationId !== other.organizationId) return false;
    if (this.name !== other.name) return false;
    if (this.type !== other.type) return false;
    if (this.position !== other.position) return false;
    if (this.questId !== other.questId) return false;
    if (this.createdAt !== other.createdAt) return false;
    if (this.updatedAt !== other.updatedAt) return false;
    if (this.deletedAt !== other.deletedAt) return false;
    if (this.liftFloors.length !== other.liftFloors.length) return false;
    for (let i = 0; i < this.liftFloors.length; i++) {
      const a = this.liftFloors[i];
      const b = other.liftFloors[i];
      if (a !== null && b !== null) {
        if (!a.equals(b)) return false;
      } else if (a !== b) return false;
    }
    if (this.carNum !== other.carNum) return false;
    if (this.vendorLiftPath !== other.vendorLiftPath) return false;
    if (this.vendorGroupName !== other.vendorGroupName) return false;
    if (this.vendorPathsProvided !== other.vendorPathsProvided) return false;
    return true;
  }
}

export function verifyLift(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 4);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyUuid(verifier, fieldPos + tableOffset);
      }
    }
    verifier.checkRequiredField(tablePos, 4, "id");
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 6);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyUuid(verifier, fieldPos + tableOffset);
      }
    }
    verifier.checkRequiredField(tablePos, 6, "bank_id");
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 8);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyUuid(verifier, fieldPos + tableOffset);
      }
    }
    verifier.checkRequiredField(tablePos, 8, "organization_id");
    {
      const pos = verifier.checkOffsetField(tablePos, 10);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkRequiredField(tablePos, 10, "name");
    verifier.checkScalarField(tablePos, 12, 1);
    verifier.checkScalarField(tablePos, 14, 4);
    verifier.checkScalarField(tablePos, 16, 2);
    {
      const pos = verifier.checkOffsetField(tablePos, 18);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 20);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 22);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 24);
      if (pos !== 0) {
        verifier.checkVectorOfTables(pos, verifyLiftFloor);
      }
    }
    verifier.checkScalarField(tablePos, 26, 2);
    {
      const pos = verifier.checkOffsetField(tablePos, 28);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 30);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkScalarField(tablePos, 32, 1);
  } finally {
    verifier.popDepth();
  }
}
